import React from "react";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import UploadIcon from "../../../../assets/images/icons/upload.png";
import Eyecon from "../../../../assets/images/icons/eyeNew.png";
import { AccountAggregatorInfoCard } from "./AccountAggregatorInfoCard";

type Props = {
  item: any;
  isXsOrSm: boolean;
  partnerStartedJourney: boolean;
  hideUploadButton?: boolean;
  hideAccountAggregator?: boolean;
  uploadDocumentLoader: any[];
  digiLockerLoaderId: any[];
  viewDocumentLoader: any[];
  uploadedVia: any;
  onUploadDocument: (docId: any, item: any) => void;
  onViewDocument: (item: any, index?: number) => void;
  onOpenAccountAggregatorModal: () => void;
  onCreateFIData?: (item: any) => void;
  onGetFIData?: (item: any) => void;
  showFIButtons?: boolean;
  showGetFIButton?: boolean;
};

export function DocumentItemCard({
  item,
  isXsOrSm,
  partnerStartedJourney,
  hideUploadButton = false,
  hideAccountAggregator = false,
  uploadDocumentLoader,
  digiLockerLoaderId,
  viewDocumentLoader,
  onUploadDocument,
  onViewDocument,
  onOpenAccountAggregatorModal,
  onCreateFIData,
  onGetFIData,
  showFIButtons,
  showGetFIButton,
}: Props) {
  const statusBg =
    item?.userDocs?.length > 0 ? "rgba(40, 199, 111, 0.16)" : "#ffebee";
  const statusFg =
    item?.userDocs?.length > 0 ? "rgba(40, 199, 111, 1)" : "#d32f2f";

  const docIdForUpload = partnerStartedJourney
    ? String(item?.documentCategoryId)
    : item?.id;

  const canShowLoader =
    uploadDocumentLoader.includes(item?.id) ||
    digiLockerLoaderId.includes(item?.id);
  return (
    <>
      {Array.isArray(item?.userDocs) && item?.userDocs.length > 1 ?
        (
          item?.userDocs.map((doc: any, index: number) => (

            <Box
              sx={{
                p: 2,
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
              }}
            >
              <Grid container spacing={2} alignItems="center" key={index}>
                <Grid item xs={12} sm={7}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#1F2233",
                      }}
                    >
                      {item?.docName} {doc?.bankName === "manual_bank_statement" ? "" : doc?.bankName}
                      {item.isMandatory && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </Typography>

                    {isXsOrSm && (
                      <Box
                        sx={{
                          backgroundColor: statusBg,
                          color: statusFg,
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: 500,
                          textTransform: "uppercase",
                        }}
                      >
                        {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
                      </Box>
                    )}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#666",
                      lineHeight: 1.4,
                    }}
                  >
                    {item?.description}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={5}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {!isXsOrSm && (
                    <Box
                      sx={{
                        backgroundColor: statusBg,
                        color: statusFg,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: 500,
                        textTransform: "uppercase",
                      }}
                    >
                      {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
                    </Box>
                  )}

                  {item?.userDocs?.length > 0 ? (
                    <>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 2,
                          mt: isXsOrSm ? 1 : 0,
                        }}
                      >
                        {!partnerStartedJourney && !hideUploadButton && (
                          <Button
                            variant="outlined"
                            startIcon={
                              <img
                                src={UploadIcon}
                                alt="Upload"
                                style={{ height: 16, width: 16 }}
                              />
                            }
                            onClick={() => onUploadDocument(docIdForUpload, item)}
                            sx={{
                              textTransform: "none",
                              borderColor: "#00b3b5",
                              color: "#00b3b5",
                              "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                              px: 2,
                              py: 0.5,
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: 500,
                              minWidth: "auto",
                              whiteSpace: "nowrap",
                            }}
                            disabled={uploadDocumentLoader.includes(item?.id)}
                          >
                            {uploadDocumentLoader.includes(item?.id) ? (
                              // <CircularProgress size={16} />
                              "Re-Upload"
                            ) : (
                              "Re-Upload"
                            )}
                          </Button>
                        )}

                        <Button
                          startIcon={
                            viewDocumentLoader.includes(doc?.id) ? (
                              <CircularProgress size={16} sx={{ color: "#00b3b5" }} />
                            ) : (
                              <img
                                src={Eyecon}
                                alt="View"
                                style={{ height: 16, width: 16 }}
                              />
                            )
                          }
                          onClick={() => onViewDocument(item, index)}
                          disabled={viewDocumentLoader.includes(doc?.id)}
                          sx={{
                            textTransform: "none",
                            color: "#00b3b5",
                            "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                            px: 2,
                            py: 0.5,
                            mt: isXsOrSm ? 1 : 0,
                            fontSize: "14px",
                            fontWeight: 500,
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                          }}
                        >
                          View
                        </Button>

                      </Box>
                    </>
                  ) : (
                    <>
                      {!partnerStartedJourney && !hideUploadButton && (
                        <Button
                          variant="outlined"
                          startIcon={
                            <img
                              src={UploadIcon}
                              alt="Upload"
                              style={{ height: 16, width: 16 }}
                            />
                          }
                          onClick={() => onUploadDocument(docIdForUpload, item)}
                          sx={{
                            textTransform: "none",
                            borderColor: "#00b3b5",
                            color: "#00b3b5",
                            "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                            px: 2,
                            py: 0.5,
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: 500,
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                          }}
                          disabled={canShowLoader}
                        >
                          {uploadDocumentLoader.includes(item?.id) ? (
                            <CircularProgress size={16} />
                          ) : (
                            "Upload"
                          )}
                        </Button>
                      )}

                    </>
                  )}
                </Grid>

                {!hideAccountAggregator &&
                  item?.uploadedVia === "account_agreegator" &&
                  item?.userDocs?.length === index + 1 && (
                  <Grid item xs={12}>
                    <AccountAggregatorInfoCard
                      onOpenAccountAggregatorModal={onOpenAccountAggregatorModal}
                      onCreateFIData={onCreateFIData ? () => onCreateFIData(item) : undefined}
                      onGetFIData={onGetFIData ? () => onGetFIData(item) : undefined}
                      showFIButtons={showFIButtons}
                      showGetFIButton={showGetFIButton}
                    />
                  </Grid>
                  )}
              </Grid>
            </Box>
          ))
        ) : (

          <Box
            sx={{
              p: 2,
              borderRadius: "8px",
              border: "1px solid #e0e0e0",
              backgroundColor: "#fff",
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={7}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#1F2233",
                    }}
                  >
                    {item?.docName}{" "}
                    {item.isMandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </Typography>

                  {isXsOrSm && (
                    <Box
                      sx={{
                        backgroundColor: statusBg,
                        color: statusFg,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: 500,
                        textTransform: "uppercase",
                      }}
                    >
                      {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
                    </Box>
                  )}
                </Box>

                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    lineHeight: 1.4,
                  }}
                >
                  {item?.description}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={5}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {!isXsOrSm && (
                  <Box
                    sx={{
                      backgroundColor: statusBg,
                      color: statusFg,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
                  </Box>
                )}

                {item?.userDocs?.length > 0 ? (
                  <>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 2,
                        mt: isXsOrSm ? 1 : 0,
                      }}
                    >

                      {!partnerStartedJourney && !hideUploadButton && (
                        <Button
                          variant="outlined"
                          startIcon={
                            <img
                              src={UploadIcon}
                              alt="Upload"
                              style={{ height: 16, width: 16 }}
                            />
                          }
                          onClick={() => onUploadDocument(docIdForUpload, item)}
                          sx={{
                            textTransform: "none",
                            borderColor: "#00b3b5",
                            color: "#00b3b5",
                            "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                            px: 2,
                            py: 0.5,
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: 500,
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                          }}
                          disabled={uploadDocumentLoader.includes(item?.id)}
                        >
                          {uploadDocumentLoader.includes(item?.id) ? (
                            <CircularProgress size={16} />
                          ) : (
                            "Re-Upload"
                          )}
                        </Button>
                      )}

                      <Button
                        startIcon={
                          viewDocumentLoader.includes(item?.id) ? (
                            <CircularProgress size={16} sx={{ color: "#00b3b5" }} />
                          ) : (
                            <img
                              src={Eyecon}
                              alt="View"
                              style={{ height: 16, width: 16 }}
                            />
                          )
                        }
                        onClick={() => onViewDocument(item, 0)}
                        disabled={viewDocumentLoader.includes(item?.id)}
                        sx={{
                          textTransform: "none",
                          color: "#00b3b5",
                          "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                          px: 2,
                          py: 0.5,
                          mt: isXsOrSm ? 1 : 0,
                          fontSize: "14px",
                          fontWeight: 500,
                          minWidth: "auto",
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </Button>
                    </Box>

                  </>
                ) : (
                  <>
                    {!partnerStartedJourney && !hideUploadButton && (
                      <Button
                        variant="outlined"
                        startIcon={
                          <img
                            src={UploadIcon}
                            alt="Upload"
                            style={{ height: 16, width: 16 }}
                          />
                        }
                        onClick={() => onUploadDocument(docIdForUpload, item)}
                        sx={{
                          textTransform: "none",
                          borderColor: "#00b3b5",
                          color: "#00b3b5",
                          "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                          px: 2,
                          py: 0.5,
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: 500,
                          minWidth: "auto",
                          whiteSpace: "nowrap",
                        }}
                        disabled={canShowLoader}
                      >
                        {uploadDocumentLoader.includes(item?.id) ? (
                          <CircularProgress size={16} />
                        ) : (
                          "Upload"
                        )}
                      </Button>
                    )}

                  </>
                )}
              </Grid>

              {!hideAccountAggregator && item?.uploadedVia === "account_agreegator" && (
                <Grid item xs={12}>
                  <AccountAggregatorInfoCard
                    onOpenAccountAggregatorModal={onOpenAccountAggregatorModal}
                    onCreateFIData={onCreateFIData ? () => onCreateFIData(item) : undefined}
                    onGetFIData={onGetFIData ? () => onGetFIData(item) : undefined}
                    showFIButtons={showFIButtons}
                    showGetFIButton={showGetFIButton}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
    </>
  );
}

